import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Api } from "../../../BackendApi/api";
import '../MobileProductOverlay.css'
import { useNavigate } from "react-router-dom"
import MobileConfirmPopup from "../../../Component/MobileConfirmPopup/MobileConfirmPopup";

const MobileEditProductOverlay = ({ product, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    ProductName: "",
    Description: "",
    ProductMRP: "",
    ProductSellingPrice: "",
    AllotCoins: "",
    CurrentStock: "",
    ProductImages: [],
    Status: "Active",
  });

  const [categoryName, setCategoryName] = useState("");
  const [preview, setPreview] = useState([]);
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "success",
  });
  const navigate = useNavigate();

  const productNameRef = useRef(null); 

  useEffect(() => {
    if (!product) return;

    setFormData({
      ProductName: product.ProductName || "",
      Description: product.Description || "",
      ProductMRP: product.ProductMRP || "",
      ProductSellingPrice: product.ProductSellingPrice || "",
      AllotCoins: product.AllotCoins || "",
      CurrentStock: product.CurrentStock || "",
      ProductImages: product.ProductImages || [],
      Status: product.Status === "true" ? "Active" : "Deactive",
    });

    setCategoryName(product.CategoryName || "N/A");

    if (product.ProductImages && product.ProductImages.length > 0) {
      setPreview(product.ProductImages.map((img) => img));
    }

    if (productNameRef.current) {
      productNameRef.current.focus();
    }
  }, [product]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "ProductImages") {
      const fileArray = Array.from(files);
      setFormData((prev) => ({ ...prev, ProductImages: fileArray }));
      setPreview(fileArray.map((file) => URL.createObjectURL(file)));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setPopup({
          show: true,
          message: "Please login first!",
          type: "warning",
        });
        setLoading(false);
        return;
      }

      const payload = {
        _id: product._id,
        ...formData,
        CategoryId: product.CategoryId,
        Status: formData.Status === "Active" ? "true" : "false",
      };

      const res = await axios.post(Api.editProducts, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token} `,
        },
      });

      if (
        res.data.status === 0 &&
        ["Invalid AuthToken", "AuthToken is required"].includes(res.data.message)
      ) {
        navigate("/");
        return;
      }

      setPopup({
        show: true,
        message: res.data.message || "Product updated successfully!",
        type: "success",
      });
    } catch (error) {
      console.error("❌ Error updating product:", error);
      setPopup({
        show: true,
        message:
          error.response?.data?.message || "Failed to update product",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePopupClose = () => {
    setPopup({ ...popup, show: false });
    if (popup.type === "success") {
      if (onSave) onSave();
      onClose();
    }
  };

  return (
    <div className="mobile-product-overlay">
      <div className="mobile-product-overlay-content">
        <h2>Edit Product</h2>
        <form className="mobile-product-overlay-form" onSubmit={handleSubmit}>
          <label>
            Category
            <div
              style={{
                padding: "7px",
                background: "#f2f2f2",
                borderRadius: "4px",
                marginTop: "4px",
              }}
            >
              {categoryName}
            </div>
          </label>

          <label>
            Product Name
            <input
              ref={productNameRef}
              name="ProductName"
              value={formData.ProductName}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Description
            <input
              type="text"
              name="Description"
              value={formData.Description}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            MRP
            <input
              type="number"
              name="ProductMRP"
              value={formData.ProductMRP}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Selling Price
            <input
              type="number"
              name="ProductSellingPrice"
              value={formData.ProductSellingPrice}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Coins
            <input
              type="number"
              name="AllotCoins"
              value={formData.AllotCoins}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Current Stock
            <input
              type="number"
              name="CurrentStock"
              value={formData.CurrentStock}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Status
            <select
              name="Status"
              value={formData.Status}
              onChange={handleChange}
              required
            >
              <option value="Active">Active</option>
              <option value="Deactive">Deactive</option>
            </select>
          </label>

          <label>
            Product Images
            <input
              type="file"
              name="ProductImages"
              accept="image/*"
              multiple
              onChange={handleChange}
            />
          </label>

          {preview.length > 0 && (
            <div style={{ marginTop: "10px" }}>
              <p>Preview:</p>
              {preview.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt="Preview"
                  style={{ width: "80px", marginRight: "8px" }}
                />
              ))}
            </div>
          )}
        </form>
          <div className="product-overlay-buttons full-width">
            <button type="button" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
      </div>

      <MobileConfirmPopup
        show={popup.show}
        message={popup.message}
        type={popup.type}
        onClose={() => handlePopupClose(popup.type)}
      />
    </div>
  );
};

export default MobileEditProductOverlay;
